import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { AuthModal } from "./AuthModal";
import { BetaKeyModal } from "./BetaKeyModal";
import { useWorkspaceDependencies } from "../../hooks/workspace/useWorkspaceDependencies";
import { useTranslation } from "react-i18next";

interface WorkspaceModalsProps {
  dependencies: ReturnType<typeof useWorkspaceDependencies>;
}

export function WorkspaceModals({ dependencies }: WorkspaceModalsProps) {
  const { t } = useTranslation("polls");
  const { user, signOut, toast, modals } = dependencies;
  const { auth, signOut: signOutModal, betaKey } = modals;

  return (
    <>
      <AuthModal open={auth.open} onOpenChange={auth.setOpen} />
      <BetaKeyModal open={betaKey.open} onOpenChange={betaKey.setOpen} />

      <AlertDialog open={signOutModal.open} onOpenChange={signOutModal.setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("sign_out.title")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("sign_out.confirm")}
              <br />
              <br />
              <span className="font-medium">
                {t("sign_out.logged_in_as", { email: user?.email })}
              </span>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t("sign_out.cancel")}</AlertDialogCancel>
            <AlertDialogAction
              onClick={async () => {
                try {
                  await signOut();
                  toast({
                    title: t("sign_out.success_title"),
                    description: t("sign_out.success_description"),
                  });
                  signOutModal.setOpen(false);
                  // Forcer le rechargement
                  setTimeout(() => {
                    window.location.href = "/";
                  }, 500);
                } catch {
                  toast({
                    title: t("sign_out.error_title"),
                    description: t("sign_out.error_description"),
                    variant: "destructive",
                  });
                }
              }}
              className="bg-red-600 hover:bg-red-700"
            >
              {t("sign_out.action")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
